"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgScreenUpdate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M144.675 63.795C134.132 50.802 118.036 42.498 100 42.498c-31.757 0-57.501 25.745-57.501 57.502 0 9.605 2.355 18.661 6.52 26.621m6.306 9.583c10.543 12.993 26.64 21.297 44.675 21.297 31.757 0 57.501-25.744 57.501-57.501 0-9.505-2.306-18.47-6.389-26.37",
    stroke: props.color || '#052E40',
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.996 63.504H144.5V47m-72.504 89.498h-16.5v16.498M111.428 72.5c4.102 0 7.352 3.162 7.495 6.998l.005.291v40.444c0 3.87-3.155 7.118-7.219 7.262l-.301.005H88.571c-4.102 0-7.351-3.162-7.495-6.998l-.005-.291V79.767c0-3.87 3.156-7.118 7.22-7.262l.3-.005h22.837z",
    stroke: props.color || '#052E40',
    strokeWidth: 5
  }));
}

var _default = SvgScreenUpdate;
exports["default"] = _default;